module.exports = __webpack_public_path__ + "img/482.7d8bdc30.jpg";